import { NUMBER_SIZE, NUMBER_SIZES } from '../../../../constants/size'

import { radioGroup } from './radioGroup'

/**
 * @param {string} name - Property name
 * @param {NumberSize} value - Default value
 * @param {Iterable<NumberSize>} options
 */
export function numberSize(
  name,
  value = NUMBER_SIZE.size40,
  options = NUMBER_SIZES
) {
  return radioGroup(name, value, { options })
}
